import {createSvgIcon} from '../create-svg-icon';

export const ArrowUpwardIcon = createSvgIcon(
  <path d="m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z" />
, 'ArrowUpwardOutlined');
